
      import 'https://cdn.jsdelivr.net/gh/orestbida/cookieconsent@3.0.1/dist/cookieconsent.umd.js';

      // Function to load Google Analytics
      function loadGoogleAnalytics() {
        if (document.getElementById('ga-script')) return;
        
        var script = document.createElement('script');
        script.id = 'ga-script';
        script.async = true;
        script.src = 'https://www.googletagmanager.com/gtag/js?id=G-FM920ZC3LN';
        document.head.appendChild(script);
        
        script.onload = function() {
          gtag('js', new Date());
          gtag('config', 'G-FM920ZC3LN');
        };
      }

      CookieConsent.run({
        guiOptions: {
          consentModal: {
            layout: 'box wide',
            position: 'bottom right',
            equalWeightButtons: true,
            flipButtons: false
          },
          preferencesModal: {
            layout: 'box',
            position: 'right',
            equalWeightButtons: true,
            flipButtons: false
          }
        },
        categories: {
          necessary: {
            enabled: true,
            readOnly: true
          },
          analytics: {
            autoClear: {
              cookies: [
                { name: /^_ga/ },
                { name: '_gid' }
              ]
            }
          },
          marketing: {}
        },
        language: {
          default: 'en',
          translations: {
            en: {
              consentModal: {
                title: 'Cookie Preferences',
                description: 'We use cookies to enhance your browsing experience, serve personalized content, and analyze our traffic. By clicking "Accept All", you consent to our use of cookies.',
                acceptAllBtn: 'Accept All',
                acceptNecessaryBtn: 'Reject All',
                showPreferencesBtn: 'Manage Preferences',
                footer: '<a href="/privacy-policy">Privacy Policy</a>'
              },
              preferencesModal: {
                title: 'Cookie Preferences',
                acceptAllBtn: 'Accept All',
                acceptNecessaryBtn: 'Reject All',
                savePreferencesBtn: 'Save Preferences',
                closeIconLabel: 'Close',
                sections: [
                  {
                    title: 'Cookie Usage',
                    description: 'We use cookies to ensure the basic functionalities of the website and to enhance your online experience. You can choose to opt-in or out of each category whenever you want.'
                  },
                  {
                    title: 'Necessary Cookies',
                    description: 'These cookies are essential for the website to function properly and cannot be disabled.',
                    linkedCategory: 'necessary'
                  },
                  {
                    title: 'Analytics Cookies',
                    description: 'These cookies help us understand how visitors interact with our website by collecting and reporting information anonymously. This includes Google Analytics.',
                    linkedCategory: 'analytics'
                  },
                  {
                    title: 'Marketing Cookies',
                    description: 'These cookies are used to track visitors across websites to display relevant advertisements.',
                    linkedCategory: 'marketing'
                  },
                  {
                    title: 'More Information',
                    description: 'For any questions regarding our cookie policy, please <a href="/contact">contact us</a>.'
                  }
                ]
              }
            }
          }
        },
        onFirstConsent: ({cookie}) => {
          if(CookieConsent.acceptedCategory('analytics')) {
            gtag('consent', 'update', { 'analytics_storage': 'granted' });
            loadGoogleAnalytics();
          }
          if(CookieConsent.acceptedCategory('marketing')) {
            gtag('consent', 'update', {
              'ad_storage': 'granted',
              'ad_user_data': 'granted',
              'ad_personalization': 'granted'
            });
          }
        },
        onConsent: ({cookie}) => {
          if(CookieConsent.acceptedCategory('analytics')) {
            gtag('consent', 'update', { 'analytics_storage': 'granted' });
            loadGoogleAnalytics();
          } else {
            gtag('consent', 'update', { 'analytics_storage': 'denied' });
          }
          if(CookieConsent.acceptedCategory('marketing')) {
            gtag('consent', 'update', {
              'ad_storage': 'granted',
              'ad_user_data': 'granted',
              'ad_personalization': 'granted'
            });
          } else {
            gtag('consent', 'update', {
              'ad_storage': 'denied',
              'ad_user_data': 'denied',
              'ad_personalization': 'denied'
            });
          }
        },
        onChange: ({cookie, changedCategories}) => {
          if(changedCategories.includes('analytics')) {
            if(CookieConsent.acceptedCategory('analytics')) {
              gtag('consent', 'update', { 'analytics_storage': 'granted' });
              loadGoogleAnalytics();
            } else {
              gtag('consent', 'update', { 'analytics_storage': 'denied' });
            }
          }
          if(changedCategories.includes('marketing')) {
            if(CookieConsent.acceptedCategory('marketing')) {
              gtag('consent', 'update', {
                'ad_storage': 'granted',
                'ad_user_data': 'granted',
                'ad_personalization': 'granted'
              });
            } else {
              gtag('consent', 'update', {
                'ad_storage': 'denied',
                'ad_user_data': 'denied',
                'ad_personalization': 'denied'
              });
            }
          }
        }
      });

      // Expose showPreferences to window for footer link
      window.showCookiePreferences = () => CookieConsent.showPreferences();
    